import { Chip } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { Associations, ProfileItemResponse } from 'src/modules/invoice/models/invoiceTemplate';

type ListDisplayProps = {
  items: Associations[] | ProfileItemResponse[];
  // Anges för att kunna ta bort poster (visar kryss på varje chip).
  onDelete?: (item: Associations | ProfileItemResponse) => void;
};

export const ListDisplay = (props: ListDisplayProps) => {
  const { items, onDelete } = props;

  const getItemKey = (item: Associations | ProfileItemResponse) => {
    return (item as Associations).id ?? (item as ProfileItemResponse).memberProfileItem_id;
  };

  return (
    <Stack direction='row' spacing={1} sx={{ flexWrap: 'wrap', px: 3 }}>
      {items.length > 0 &&
        items.map((item) => {
          return (
            <Box key={getItemKey(item)} mb={1}>
              <Chip label={item.name} onDelete={onDelete ? () => onDelete(item) : undefined} sx={{ mt: 0.5, fontStyle: 'normal' }} />
            </Box>
          );
        })}
    </Stack>
  );
};
